import React from "react";
import { VerticalSteps, Text } from "ui-components";

import {
  StepDescription,
  StepLabel,
  StepWrapper
} from "@common/styled/sidebar";

const { Step, SubSection } = VerticalSteps;

class Stepper extends React.Component {
  /**
   * Render a Step component with optional substeps
   * @param  {object} step              Step object to render
   * @param  {int}    idx               Unique key for React list rendering
   * @param  {object} [subsection=null] Rendered subsection with substeps
   * @return {object}                   Rendered Step component
   */
  renderStep = (step, idx, subsection = null) => {
    // Create a label for the step
    const label = (
      <StepLabel>
        <Text size="4">{step.title}</Text>
      </StepLabel>
    );

    // Render the component with an optional substeps section
    return (
      <Step key={idx} label={label} bulletTextType="medium" bullet={step.label}>
        <StepWrapper>
          <Text type="medium" size="5" paddingB="1">
            Description
          </Text>
          <StepDescription>
            {step.description.map((item, idx) => <div key={idx}>{item}</div>)}
          </StepDescription>
        </StepWrapper>
        {/* Rendered substeps section (optional) */}
        {subsection}
      </Step>
    );
  };

  /**
   * Render a subsection containing the substeps of a Step
   * @param  {object} step Step object to render subsections for
   * @return {object}      Rendered subsection
   */
  renderSubsection = step => {
    // Create the label for the substep (needs the substep number)
    const label = (title, idx) => {
      return (
        <Text type="medium" size="5">
          {idx + 1}. {title}
        </Text>
      );
    };

    // Render the subsection and its contained Steps
    return (
      <SubSection activeStep={this.props.stepsMeta.activeSubStep}>
        {step.subsections.map((substep, idx) => (
          <Step key={idx} label={label(substep.subTitle, idx)} />
        ))}
      </SubSection>
    );
  };

  render() {
    // The steps are stored within the global store
    const steps = [this.props.section];
    const activeStep = this.props.stepsMeta.activeStep;

    return (
      <div>
        <VerticalSteps activeStep={activeStep} autoHideContent>
          {/* Steps with subsections pass the rendered subsection to the individual Step render*/}
          {steps.map(
            (step, idx) =>
              step.subsections
                ? this.renderStep(step, idx, this.renderSubsection(step))
                : this.renderStep(step, idx)
          )}
        </VerticalSteps>
      </div>
    );
  }
}

export default Stepper;



// WEBPACK FOOTER //
// ./src/common/components/Stepper/Stepper.jsx